
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IGLBatchReceiptPayer, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * GLBatchReceiptPayerLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class GLBatchReceiptPayerLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<IGLBatchReceiptPayer[]> {
        return this.$apiService.sendAuth("IGLBatchReceiptPayerLookupService/Lookup", pCriteria);
    }
}
